// extracted by mini-css-extract-plugin
export default {"modal":"modal__dB0zO","content":"content__kVxy4"};